// imports section Start
import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useSelector, useDispatch } from "react-redux";
import { GUEST_API_07 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
// imports section End

export default function GuestHeader({ toggleTheme, mode }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [store, setStore] = useState([]);
  const [error, setError] = useState(null);
  // Hooks end
  const queryParams = new URLSearchParams(window.location.search);

  const guestDecoded = useSelector((state) => state.guestDecoded);

  console.log("Guest Decoded Values:", guestDecoded);

  // Destructure `guestDecoded` with default fallback values
  // const {
  //   COMPCODE = "",
  //   LOCCODE = "",
  //   RESTCODE = null,
  //   // TABLECODE = null,
  // } = guestDecoded || {};

  const COMPCODE  = atob(queryParams.get("compcode"));
  const LOCCODE  = atob(queryParams.get("loccode"));
  const RESTCODE  = atob(queryParams.get("restcode"));

  useEffect(() => {
    fetchStore(COMPCODE, LOCCODE, RESTCODE);
  }, []);

  // Get user parameters from Redux store
  const fetchStore = async () => {
    try {
      const params = {
        COMPCODE: COMPCODE,
        LOCCODE: LOCCODE,
        RESTCODE: RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const storeData = await externalgetApi(GUEST_API_07, "GET", params);
      console.log("storeData", storeData);
      setStore(storeData);
      // fetchAllItems(compcode, loccode, restcode);
    } catch (error) {
      setError(error);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: theme.palette.primary.main }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            fontWeight={600}
            noWrap
            component="div"
            sx={{ flexGrow: 1 }}
          >
            {store.length > 0 ? store[0].RESTNAME : "Loading..."}
          </Typography>
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label="toggle theme"
            onClick={toggleTheme}
          >
            {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
